import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import compose from 'recompose/compose';
import { useDrop } from 'react-dnd';
import {
  withStyles,
} from '@material-ui/core';
import {
  debounce,
} from 'lodash';
import styles from './styles';
import {
  ENTITY_PICKER_TYPE_CATEGORY,
} from '../constants';

export const EntityDropTarget = ({ addEntity, classes, index, showDropTargets, type }) => {
  const ref = useRef(null);
  const debouncedAddEnity = debounce((id, index) => {
    addEntity(id, index);
  }, 300);
  const [{ highlighted }, drop] = useDrop({
    accept: [type],
    collect: (monitor) => {
      return ({
        highlighted: !!monitor.isOver(),
      });
    },
    drop(item) {
      debouncedAddEnity(item.id, index);
    },
    item: {
      index,
      type,
    },
  });
  drop(ref);
  const containerWrapperClass = (type === ENTITY_PICKER_TYPE_CATEGORY) ? classes.containerWrapper : '';
  const containerClasses = clsx(classes.container, highlighted ? classes.selectedContainer : '');
  return (<div className={containerWrapperClass} ref={ref}>
    {showDropTargets &&
    <div
      className={containerClasses}
      data-apim-test={`entity-drop-target-${index}`}
    >
      <div className={classes.innerText}>Drop here</div>
    </div>}
  </div>)
};

EntityDropTarget.propTypes = {
  addEntity: PropTypes.func,
  classes: PropTypes.object,
  index: PropTypes.number,
  showDropTargets: PropTypes.bool,
  type: PropTypes.string,
};

export default compose(
  withStyles(styles),
)(EntityDropTarget);